/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

type CollectionItemRowArgs = {
  item: Record<string, any>;
  columns: string[];
};

export default class CollectionItemRow extends Component<CollectionItemRowArgs> {
  @tracked expanded = false;
}
